import {
    FetchState,
    PersonaState
} from "@/shared/types";
import * as UserService from "@/shared/api/userService";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: PersonaState = {
    fetchState: FetchState.Uninitialized,
    persona: null
};


export const usePersonaStore = defineStore("persona", {
    state: (): PersonaState => (_.cloneDeep(initialState)),
    getters: {
        personaAndIsLoaded: state => state.fetchState === FetchState.Loaded ? ({ isLoaded: true, name: state.persona })
            : ({ isLoaded: false })
    },
    actions: {
        setPersona (value) {
            this.fetchState = FetchState.Loaded;
            this.persona = value;
        },
        setFetching () {
            this.fetchState = FetchState.Loading;
        },
        getPersonaType () {
            if (this.fetchState === FetchState.Uninitialized) {
                this.setFetching();
                return UserService.getPersona()
                    .then(personaName => this.setPersona(personaName));
            }
        },
        setPersonaType (name: string) {
            return UserService.setPersona(name)
                .then(personaName => this.setPersona(name));
        }
    }
});
